import {
    Directive,
    ElementRef,
    Optional,
    Renderer2,
    inject,
} from '@angular/core';
import { Observable, takeUntil } from 'rxjs';
import { IThemeService } from '../../interfaces';
import { WdxAppThemeService, WdxDestroyClass } from '../../services';

interface IThemeProvider {
    currentTheme$: Observable<string>;
}
@Directive({
    selector: '[wdxUtilsAgGridTheme]',
})
export class WdxAgGridThemeDirective extends WdxDestroyClass {
    private elementRef = inject(ElementRef);
    private renderer = inject(Renderer2);

    private themeProvider: IThemeProvider;

    constructor(
        @Optional() private themeService: IThemeService,
        @Optional() private appThemeService: WdxAppThemeService,
    ) {
        super();
        this.themeProvider = this.themeService
            ? this.themeService
            : this.appThemeService;

        this.themeProvider.currentTheme$
            .pipe(takeUntil(this.destroyed$))
            .subscribe((theme) => {
                if (theme === 'Dark') {
                    this.renderer.removeClass(
                        this.elementRef.nativeElement,
                        'ag-theme-quartz',
                    );
                    this.renderer.addClass(
                        this.elementRef.nativeElement,
                        'ag-theme-quartz-dark',
                    );
                    return;
                }
                this.renderer.removeClass(
                    this.elementRef.nativeElement,
                    'ag-theme-quartz-dark',
                );
                this.renderer.addClass(
                    this.elementRef.nativeElement,
                    'ag-theme-quartz',
                );
            });
    }
}
